<div class="modal-body">
    <div class="modal-header">
        <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'" (click)="closeModal()">
        </div>
    </div>
    <div class="modal-content-body">
        <div class="ese-chooser-title lato-18-n-vw">
            Create an Emerging Security Event (ESE) Assessment
        </div>
        <div class="ese-chooser-options">
            <div class="ese-option-card" (click)="onUpload()">
                <div class="ese-option-icon" cygovSvgIcon [svgName]="'upload_collection'"></div>
                <div class="ese-option-label lato-16-n-vw">Upload</div>
            </div>
            <div class="ese-option-card" (click)="onBuild()">
                <div class="ese-option-icon" cygovSvgIcon [svgName]="'template-icon'"></div>
                <div class="ese-option-label lato-16-n-vw">Build</div>
            </div>
            <div class="ese-option-card template-card" *ngIf="isFromVendorListing"
                [ngClass]="{'disabled-card': !isTemplateAvailable}"
                (click)="isTemplateAvailable && onTemplate()">
                <div class="ese-option-icon" cygovSvgIcon [svgName]="'template-icon-2'"></div>
                <div class="ese-option-label lato-16-n-vw">Template</div>
            </div>
        </div>
    </div>
    <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)"
        accept=".xls,.xlsx" />
</div>